import { createContext, useContext, useEffect, useState } from "react";

const LANGS = ["it", "en", "zh"];

const dict = {
  nav: {
    home: { it: "Home", en: "Home", zh: "首页" },
    atelier: { it: "L'Atelier", en: "The Atelier", zh: "工作室" },
    collection: { it: "Collezione", en: "Collection", zh: "婚纱系列" },
    rental: { it: "Noleggio & Vendita su Ordinazione", en: "Rental & Made to Order", zh: "租赁与订购" },
    appointments: { it: "Appuntamenti", en: "Appointments", zh: "预约" },
    book: { it: "Prenota un Appuntamento", en: "Book an Appointment", zh: "预约到店" },
  },
  hero: {
    eyebrow: { it: "Atelier Sposa — Milano", en: "Bridal Atelier — Milan", zh: "米兰婚纱工作室" },
    line1: { it: "Per Lei,", en: "For Her,", zh: "为她而来，" },
    line2: { it: "il giorno più", en: "the dress of", zh: "人生最美" },
    line3: { it: "indimenticabile.", en: "her lifetime.", zh: "的那件婚纱。" },
    sub: {
      it: "Una selezione di abiti da sposa e da cerimonia firmati da designer, disponibili per il noleggio e l'acquisto su ordinazione.",
      en: "A selection of designer wedding and ceremony dresses, available for rental and made-to-order purchase.",
      zh: "设计师品牌婚纱与礼服精选，支持租赁与订购购买。",
    },
    cta: { it: "Scopri la Collezione", en: "Discover the Collection", zh: "探索婚纱系列" },
    cta2: { it: "Prenota una Prova", en: "Book a Fitting", zh: "预约试纱" },
  },
  marquee: {
    items: { it: "ATELIER PRIVATO · NOLEGGIO · VENDITA SU ORDINAZIONE · SPEDIZIONI IN EUROPA ·", en: "PRIVATE ATELIER · RENTAL · MADE TO ORDER · SHIPPING ACROSS EUROPE ·", zh: "私人工作室 · 租赁 · 订购 · 全欧配送 ·" },
  },
  home: {
    statementKicker: { it: "THE COLLECTION", en: "THE COLLECTION", zh: "婚纱系列" },
    statementTitle: { it: "L'eleganza, in ogni sua forma.", en: "Elegance, in every form.", zh: "优雅，千姿百态。" },
    statement: {
      it: "Dalle linee essenziali ai dettagli più ricercati, una selezione di abiti che interpreta la bellezza attraverso stili e personalità differenti.",
      en: "From essential lines to the most refined details, a selection of dresses that interprets beauty through different styles and personalities.",
      zh: "从简约线条到最精致的细节，甄选礼服以不同风格与个性诠释美。",
    },
    servicesKicker: { it: "OUR SERVICES", en: "OUR SERVICES", zh: "服务" },
    servicesTitle: { it: "La libertà di scegliere.", en: "The freedom to choose.", zh: "自由选择。" },
    servicesRental: { it: "NOLEGGIO", en: "RENTAL", zh: "租赁" },
    servicesRentalBody: { it: "Una selezione di abiti da sposa firmati, con prove private e modifiche sartoriali personalizzate.", en: "A selection of designer wedding dresses, with private fittings and personalized alterations.", zh: "设计师品牌婚纱精选，提供私人试穿与个性化修改。" },
    servicesMto: { it: "ACQUISTO SU ORDINAZIONE", en: "MADE TO ORDER", zh: "订购购买" },
    servicesMtoBody: { it: "Abiti da sposa dei nostri designer, disponibili su ordinazione con una consulenza dedicata.", en: "Wedding dresses by our designers, available to order with dedicated consultation.", zh: "我们设计师品牌的婚纱，支持订购并提供专属咨询。" },
    destinationKicker: { it: "DESTINATION BRIDAL", en: "DESTINATION BRIDAL", zh: "目的地婚礼" },
    destinationTitle: { it: "Il tuo abito ti aspetta in Italia.", en: "Your dress awaits you in Italy.", zh: "您的婚纱在意大利等您。" },
    destinationBody: { it: "Per servizi fotografici prematrimoniali, elopement e destination wedding. Scegli il tuo abito prima di partire e ritiralo nel nostro atelier a Milano, oppure ricevilo direttamente presso il tuo hotel o la location del matrimonio.", en: "For pre-wedding photo shoots, elopements and destination weddings. Choose your dress before you leave and collect it at our Milan atelier, or have it delivered directly to your hotel or wedding location.", zh: "适用于婚前摄影、私奔婚礼与目的地婚礼。出发前选好婚纱，可在我们的米兰工作室取衣，或直接送至您的酒店或婚礼场地。" },
    atelierKicker: { it: "THE ATELIER", en: "THE ATELIER", zh: "工作室" },
    atelierTitle: { it: "Uno spazio, solo per te.", en: "A space, just for you.", zh: "只属于您的空间。" },
    atelierBody: { it: "Un ambiente intimo e riservato nel cuore di Milano, dove scoprire le nostre collezioni attraverso un'esperienza di prova privata e personalizzata.", en: "An intimate and private space in the heart of Milan, where you can discover our collections through a private and personalized fitting experience.", zh: "米兰市中心的私密空间，通过私人个性化试穿体验探索我们的系列。" },
    appointmentKicker: { it: "YOUR APPOINTMENT", en: "YOUR APPOINTMENT", zh: "您的预约" },
    appointmentTitle: { it: "Il tuo momento, il tuo abito.", en: "Your moment, your dress.", zh: "属于您的时刻，您的婚纱。" },
    appointmentBody: { it: "Prenota una prova privata nel nostro atelier e lasciati guidare nella scelta dell'abito che ti rappresenta.", en: "Book a private fitting at our atelier and let us guide you in choosing the dress that represents you.", zh: "在我们的工作室预约私人试纱，让我们为您挑选代表您的婚纱。" },
    featuredKicker: { it: "Selezione", en: "Selection", zh: "甄选" },
    featuredTitle: { it: "Abiti in evidenza", en: "Featured Gowns", zh: "精选婚纱" },
    viewAll: { it: "Vedi tutta la collezione", en: "View the full collection", zh: "查看全部系列" },
    experienceKicker: { it: "L'Esperienza", en: "The Experience", zh: "体验" },
    experienceTitle: { it: "L'esperienza Per Lei", en: "The Per Lei experience", zh: "Per Lei 体验" },
    bookTeaser: { it: "Ogni prova è un appuntamento privato. Due ore, solo per lei.", en: "Every fitting is a private appointment. Two hours, only for her.", zh: "每次试纱皆为私人预约，两小时，只属于她。" },
  },
  collection: {
    title: { it: "La Collezione", en: "The Collection", zh: "婚纱系列" },
    sub: {
      it: "Abiti da sposa e da sposo, e abiti da cerimonia. In noleggio o su ordinazione.",
      en: "Wedding and groom attire, and ceremony dresses. For rental or made to order.",
      zh: "婚纱、新郎礼服与礼服。支持租赁与订购。",
    },
    all: { it: "Tutti", en: "All", zh: "全部" },
    designer: { it: "Designer", en: "Designer", zh: "设计师" },
    silhouette: { it: "Silhouette", en: "Silhouette", zh: "廓形" },
    fabric: { it: "Tessuto", en: "Fabric", zh: "面料" },
    category: { it: "Categoria", en: "Category", zh: "类别" },
    reset: { it: "Azzera filtri", en: "Reset filters", zh: "重置筛选" },
    empty: { it: "Nessun abito corrisponde ai filtri selezionati.", en: "No dresses match the selected filters.", zh: "没有符合条件的婚纱。" },
    from: { it: "da", en: "from", zh: "起" },
    enquire: { it: "Richiedi Informazioni", en: "Enquire About This Dress", zh: "咨询此款" },
    book: { it: "Prenota una Prova", en: "Book a Fitting", zh: "预约试纱" },
    details: { it: "Dettagli", en: "Details", zh: "详情" },
    rental: { it: "Noleggio", en: "Rental", zh: "租赁" },
    purchase: { it: "Acquisto", en: "Purchase", zh: "购买" },
    leadTime: { it: "Tempo di consegna", en: "Lead time", zh: "制作周期" },
    sizes: { it: "Taglie", en: "Sizes", zh: "尺码" },
    back: { it: "Torna alla collezione", en: "Back to collection", zh: "返回系列" },
  },
  categories: {
    bridal: { it: "Sposa", en: "Bride", zh: "新娘" },
    evening: { it: "Cerimonia", en: "Ceremony", zh: "礼服" },
    suits: { it: "Sposo", en: "Groom", zh: "新郎" },
    mother: { it: "Madre della Sposa", en: "Mother of the Bride", zh: "母亲礼服" },
  },
  collections: {
    selected: { it: "Designer", en: "Designer", zh: "设计师系列" },
    couture: { it: "Couture", en: "Couture", zh: "高级定制" },
  },
  silhouettes: {
    "A-Line": { it: "A-Line", en: "A-Line", zh: "A字裙" },
    Ballgown: { it: "Principessa", en: "Ballgown", zh: "公主裙" },
    Mermaid: { it: "Sirena", en: "Mermaid", zh: "鱼尾" },
    Sheath: { it: "Scivolato", en: "Sheath", zh: "直筒" },
  },
  fabrics: {
    Satin: { it: "Satin", en: "Satin", zh: "缎面" },
    Lace: { it: "Pizzo", en: "Lace", zh: "蕾丝" },
    Tulle: { it: "Tulle", en: "Tulle", zh: "薄纱" },
    Mikado: { it: "Mikado", en: "Mikado", zh: "米卡多" },
    Organza: { it: "Organza", en: "Organza", zh: "欧根纱" },
  },
  leadTimes: {
    "2-6 mesi": { it: "2-6 mesi", en: "2-6 months", zh: "2-6个月" },
  },
  rental: {
    title: { it: "Noleggio & Vendita su Ordinazione", en: "Rental & Made to Order", zh: "租赁与订购" },
    sub: {
      it: "Due modi di vivere l'abito perfetto: la più ampia selezione in noleggio, o l'acquisto su ordinazione. Entrambi con la cura di sempre.",
      en: "Two ways to wear the perfect dress: the widest rental selection, or made-to-order purchase. Both with the same care.",
      zh: "两种方式演绎完美礼服：最丰富的租赁甄选，或订购购买。皆以一贯的匠心呈现。",
    },
    rentalCol: { it: "Noleggio", en: "Rental", zh: "租赁" },
    mtoCol: { it: "Vendita su Ordinazione", en: "Made to Order", zh: "订购购买" },
    rentalPrice: { it: "Collezione selezionata €280–420 · Collezione couture €480–2.280", en: "Selected collection €280–420 · Couture collection €480–2,280", zh: "精选系列 €280–420 · 高定系列 €480–2,280" },
    mtoPrice: { it: "YOUR DRESS, FOREVER — Una selezione di abiti da sposa firmati da designer indipendenti, disponibili su ordinazione. Acquisto: da €780.", en: "YOUR DRESS, FOREVER — A selection of wedding dresses by independent designers, available to order. Purchase: from €780.", zh: "YOUR DRESS, FOREVER——独立设计师品牌婚纱系列，支持订购。购买：€780起。" },
    processRental: { it: "Il percorso di noleggio", en: "The rental process", zh: "租赁流程" },
    processMto: { it: "Il percorso su ordinazione", en: "The made-to-order journey", zh: "订购流程" },
    faq: { it: "Domande frequenti", en: "Frequently asked questions", zh: "常见问题" },
  },
  appointments: {
    title: { it: "Appuntamenti & Contatti", en: "Appointments & Contact", zh: "预约与联系" },
    sub: {
      it: "Prenota il tuo appuntamento privato in atelier. Ti risponderemo entro 24 ore.",
      en: "Book your private atelier appointment. We will reply within 24 hours.",
      zh: "预约您的私人到店服务，我们将在24小时内回复。",
    },
    formTitle: { it: "Richiedi un appuntamento", en: "Request an appointment", zh: "预约申请" },
    name: { it: "Nome e cognome", en: "Full name", zh: "姓名" },
    email: { it: "Email", en: "Email", zh: "邮箱" },
    phone: { it: "Telefono / WhatsApp", en: "Phone / WhatsApp", zh: "电话 / WhatsApp" },
    type: { it: "Motivo della richiesta", en: "Reason for your request", zh: "请求原因" },
    typeInitial: { it: "Noleggio abiti", en: "Dress rental", zh: "礼服租赁" },
    typeBespoke: { it: "Acquisto su ordinazione", en: "Made-to-order purchase", zh: "订购购买" },
    typeFitting: { it: "Consulenza a distanza", en: "Remote consultation", zh: "远程咨询" },
    typeRental: { it: "Altro", en: "Other", zh: "其他" },
    date: { it: "Data preferita", en: "Preferred date", zh: "期望日期" },
    message: { it: "Messaggio", en: "Message", zh: "留言" },
    send: { it: "Invia richiesta", en: "Send request", zh: "发送请求" },
    sent: { it: "Richiesta inviata. Ti risponderemo presto.", en: "Request sent. We will reply shortly.", zh: "已发送，我们将尽快回复。" },
    required: { it: "Compila i campi obbligatori.", en: "Please fill in the required fields.", zh: "请填写必填项。" },
    visit: { it: "Vieni a trovarci", en: "Visit us", zh: "到店拜访" },
    address: { it: "Via Eleonora Fonseca Pimentel 18, Milano", en: "Via Eleonora Fonseca Pimentel 18, Milan", zh: "米兰 Via Eleonora Fonseca Pimentel 18 号" },
    hours: { it: "Su appuntamento: tutti i giorni 10:00–24:00", en: "By appointment: every day 10:00–24:00", zh: "仅限预约：每天 10:00–24:00" },
    prepareTitle: { it: "COME PREPARARSI ALLA PROVA", en: "HOW TO PREPARE FOR THE FITTING", zh: "试纱准备" },
    prepareSub: { it: "Qualche piccolo consiglio per la tua visita.", en: "A few small tips for your visit.", zh: "为您的访问提供一些小建议。" },
    prepareForHer: { it: "PER LEI", en: "FOR HER", zh: "为她" },
    prepareForHim: { it: "PER LUI", en: "FOR HIM", zh: "为他" },
    prepareForHimBody: { it: "Per la prova dell'abito da sposo, consigliamo di portare una camicia, scarpe eleganti e una cintura, se disponibili.", en: "For the groom's fitting, we recommend bringing a shirt, elegant shoes and a belt, if available.", zh: "新郎试身建议携带衬衫、皮鞋和腰带（如有）。" },
    consent: { it: "Ho letto l'Informativa Privacy e acconsento al trattamento dei miei dati per rispondere alla richiesta.", en: "I have read the Privacy Policy and consent to the processing of my data to respond to my request.", zh: "我已阅读隐私政策，同意为回复我的请求而处理我的数据。" },
  },
  privacy: {
    title: { it: "Informativa Privacy", en: "Privacy Policy", zh: "隐私政策" },
    cookieTitle: { it: "Cookie Policy", en: "Cookie Policy", zh: "Cookie 政策" },
    bannerText: { it: "Utilizziamo cookie tecnici e, previo consenso, cookie di terze parti (mappe Google). Puoi accettare o rifiutare.", en: "We use technical cookies and, with your consent, third-party cookies (Google Maps). You can accept or decline.", zh: "我们使用技术Cookie，并在您同意后使用第三方Cookie（谷歌地图）。您可以接受或拒绝。" },
    accept: { it: "Accetta tutti", en: "Accept all", zh: "全部接受" },
    reject: { it: "Rifiuta", en: "Decline", zh: "拒绝" },
    enableMap: { it: "Abilita la mappa (richiede il consenso ai cookie di terze parti)", en: "Enable map (requires third-party cookie consent)", zh: "启用地图（需第三方Cookie同意）" },
    navPrivacy: { it: "Privacy", en: "Privacy", zh: "隐私" },
    navCookies: { it: "Cookie", en: "Cookies", zh: "Cookie" },
  },
  enquiry: {
    title: { it: "Richiedi informazioni", en: "Enquire about this dress", zh: "咨询此款婚纱" },
    name: { it: "Nome e cognome", en: "Full name", zh: "姓名" },
    email: { it: "Email", en: "Email", zh: "邮箱" },
    phone: { it: "Telefono (facoltativo)", en: "Phone (optional)", zh: "电话（选填）" },
    message: { it: "Messaggio", en: "Message", zh: "留言" },
    send: { it: "Invia richiesta", en: "Send enquiry", zh: "发送咨询" },
    sent: { it: "Richiesta inviata. Grazie!", en: "Enquiry sent. Thank you!", zh: "已发送，谢谢！" },
  },
  atelier: {
    title: { it: "L'Atelier", en: "The Atelier", zh: "工作室" },
    sub: {
      it: "Dal 2024, un salotto privato dedicato alla sposa contemporanea.",
      en: "Since 2024, a private salon dedicated to the contemporary bride.",
      zh: "自2024年起，专属于当代新娘的私人沙龙。",
    },
    story: { it: "La nostra storia", en: "Our story", zh: "品牌故事" },
    craft: { it: "Sartoria & artigianato", en: "Craftsmanship", zh: "工艺" },
    fabrics: { it: "La biblioteca dei tessuti", en: "The fabric library", zh: "面料库" },
  },
  footer: {
    tagline: { it: "Atelier sposa su appuntamento — Milano", en: "Bridal atelier by appointment — Milan", zh: "预约制婚纱工作室——米兰" },
    nav: { it: "Naviga", en: "Navigate", zh: "导航" },
    contact: { it: "Contatti", en: "Contact", zh: "联系方式" },
    shipping: { it: "Spedizioni in tutta Europa", en: "Shipping across Europe", zh: "全欧配送" },
    rights: { it: "Tutti i diritti riservati", en: "All rights reserved", zh: "版权所有" },
  },
  seo: {
    title: {
      home: {
        it: "Per Lei Bridal — Atelier Sposa su Appuntamento, Noleggio e Su Misura",
        en: "Per Lei Bridal — Bridal Atelier by Appointment, Rental & Made to Order",
        zh: "Per Lei Bridal——预约制婚纱工作室，租赁与订购",
      },
      atelier: {
        it: "L'Atelier — Per Lei Bridal Milano",
        en: "The Atelier — Per Lei Bridal Milan",
        zh: "工作室 — Per Lei Bridal 米兰",
      },
      collezione: {
        it: "Collezione Sposa — Per Lei Bridal Milano",
        en: "Bridal Collection — Per Lei Bridal Milan",
        zh: "婚纱系列 — Per Lei Bridal 米兰",
      },
      noleggio: {
        it: "Noleggio & Vendita su Ordinazione — Per Lei Bridal",
        en: "Rental & Made to Order — Per Lei Bridal",
        zh: "租赁与订购 — Per Lei Bridal",
      },
      appuntamenti: {
        it: "Appuntamenti & Contatti — Per Lei Bridal",
        en: "Appointments & Contact — Per Lei Bridal",
        zh: "预约与联系 — Per Lei Bridal",
      },
    },
  },
  admin: {
    title: { it: "Per Lei — Gestione Atelier", en: "Per Lei — Atelier Management", zh: "Per Lei — 工作室管理" },
    login: { it: "Accedi", en: "Sign in", zh: "登录" },
    logout: { it: "Esci", en: "Sign out", zh: "退出" },
    email: { it: "Email", en: "Email", zh: "邮箱" },
    password: { it: "Password", en: "Password", zh: "密码" },
    dresses: { it: "Abiti", en: "Dresses", zh: "婚纱" },
    inquiries: { it: "Richieste", en: "Inquiries", zh: "咨询" },
    photos: { it: "Foto in blocco", en: "Bulk photos", zh: "批量照片" },
    bulkHint: { it: "Carica più foto insieme, poi assegnale a ciascun abito. La prima foto di un abito è la copertina.", en: "Upload multiple photos at once, then assign them to each dress. A dress's first photo is its cover.", zh: "一次上传多张照片，然后分配给各婚纱。第一张为封面。" },
    assign: { it: "Assegna", en: "Assign", zh: "分配" },
    choose: { it: "Scegli abito…", en: "Choose dress…", zh: "选择婚纱…" },
    cover: { it: "copertina", en: "cover", zh: "封面" },
    add: { it: "Aggiungi abito", en: "Add dress", zh: "添加婚纱" },
    edit: { it: "Modifica", en: "Edit", zh: "编辑" },
    del: { it: "Elimina", en: "Delete", zh: "删除" },
    save: { it: "Salva", en: "Save", zh: "保存" },
    search: { it: "Cerca...", en: "Search...", zh: "搜索…" },
    status: { it: "Stato", en: "Status", zh: "状态" },
  },
};

const LanguageContext = createContext();

export const dictFull = dict;

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("it");
  useEffect(() => {
    document.documentElement.lang = lang;
    document.body.classList.toggle("zh-body", lang === "zh");
    const metas = {
      it: "Per Lei Bridal, atelier sposa su appuntamento dal 2024. Abiti da sposa e da sposo, abiti da sera e madre della sposa, in noleggio o su misura, spedizioni in tutta Europa.",
      en: "Per Lei Bridal, by-appointment bridal atelier since 2024. Wedding and groom attire, evening gowns and mother-of-the-bride outfits, for rental or made to order, shipping across Europe.",
      zh: "Per Lei Bridal，自2024年起的预约制婚纱工作室。婚纱、新郎礼服、晚礼服及母亲礼服，支持租赁与订购，全欧配送。",
    };
    let md = document.querySelector('meta[name="description"]');
    if (md) md.setAttribute("content", metas[lang]);
    let og = document.querySelector('meta[property="og:description"]');
    if (og) og.setAttribute("content", metas[lang]);
    let tw = document.querySelector('meta[name="twitter:description"]');
    if (tw) tw.setAttribute("content", metas[lang]);
  }, [lang]);
  const t = (key) => {
    const parts = key.split(".");
    let node = dict[parts[0]];
    for (let i = 1; i < parts.length && node; i++) node = node[parts[i]];
    return node && node[lang] ? node[lang] : key;
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
